import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
// import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {

	async triggerPersistentButton(path, label, sameWindow) {
		Store.emit('PLAY_SOUND', '5DeUe41lk');
		return super.triggerPersistentButton(path, label, sameWindow);
	}

	triggerActionButton(homeEntVisible) {
		let actionData = this.getCurrentActionBtnAction(homeEntVisible);
		if (actionData?.icon === 'close') {
			Store.emit('PLAY_SOUND', 'y1dRIRdC8');
		}
		return super.triggerActionButton(homeEntVisible);
	}

	triggerBurgerBtn() {
		let actionData = this.getCurrentHeaderAction();
		if (actionData?.icon === 'burger') {
			Store.emit('PLAY_SOUND', 'idoQrBNKy');
		}

		return super.triggerBurgerBtn();
	}

}